import * as Actions from "./constants";
const initialState = {
  dashboardData: [],
};

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_DASHBOARD_RECORD:
      return {
        ...state,
        dashboardData: [],
      };
    case Actions.GET_DASHBOARD_RECORD_SUCCESS:
      return {
        ...state,
        dashboardData: action.payload,
      };
    case Actions.GET_DASHBOARD_RECORD_ERROR:
      return {
        ...state,
        dashboardData: [],
      };
    default:
      return state;
  }
}
